import { useCallback, useContext } from "react";
import { useMutation, UseMutationOptions, useQueryClient } from "react-query";

import { IDeleteCommentParams } from "../domain";
import { apiServiceContext } from "../../api-service-context";
import { EntityType } from "../query-keys";

export const useDeleteComment = (options?: UseMutationOptions<any, any, IDeleteCommentParams>) => {
  const { commentsApiService } = useContext(apiServiceContext);
  const queryClient = useQueryClient();

  const mutationFn = useCallback(
    (payload: IDeleteCommentParams) =>
      commentsApiService.createCancellableRequest((cancelToken) =>
        commentsApiService.deleteComment(payload, cancelToken)
      ),
    [commentsApiService]
  );

  const mutation = useMutation<any, any, IDeleteCommentParams>(mutationFn, {
    ...options,
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries(EntityType.COMMENT_OF_USER);
      options?.onSuccess?.(...args);
    },
  });

  return mutation;
};
